import { Component, Input, DoCheck } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'campaign-status',
  templateUrl: 'campaign-status.html',
})
export class CampaignStatusComponent implements DoCheck {

  @Input() step: number;

  public status: string = '';
  public description: string = '';
  private descriptionLabels: string[] = [];
  private statusLabels: string[] = [];


  constructor(private translate: TranslateService)
  {
    this.translate.get(['campaign']).subscribe((res) => {

      this.descriptionLabels = [
        res.campaign.stepDesc1,
        res.campaign.stepDesc2,
        res.campaign.stepDesc3,
        res.campaign.stepDesc4,
        res.campaign.stepDesc5
      ];

      this.statusLabels = [
        res.campaign.stepStatus1,
        res.campaign.stepStatus2,
        res.campaign.stepStatus3,
        res.campaign.stepStatus4,
        res.campaign.stepStatus5
      ];
    });
  }

  ngDoCheck()
  {
    this.description = this.descriptionLabels[this.step - 1];
    this.status = this.statusLabels[this.step - 1];
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/status/campaign-status.component.ts